import { render, staticRenderFns } from "./ReconnectPos.vue?vue&type=template&id=12e3dd41"
import script from "./ReconnectPos.vue?vue&type=script&lang=js"
export * from "./ReconnectPos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports